export class LastMovement {
  constructor(
    public date: string | Date,
    public account: string,
    public accountType: string,
    public detail: string,
    public amount: number,
    public transactionId?: string,
    public bankId?: string
  ) {}
}
